import React, { useMemo } from 'react';
import { useSettings, OutcomeService, SiteConfigManager } from '@atlas/core';
import PropTypes from 'prop-types';

export default function Odds({ value }) {
  const { oddsFormat } = useSettings();

  return useMemo(() => {
    const zeroes = SiteConfigManager.getConfig('config.config.odds_zeroes', false);

    const formattedOdds = OutcomeService.formatOdds(value, { oddsFormat, zeroes });

    return <span>{formattedOdds}</span>;
  }, [value, oddsFormat]);
}

Odds.propTypes = { value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired };
